export default "__VITE_ASSET__f8acca29__"